import { createContext, useContext } from "react";

/** Stav zvonečku pro celou aplikaci (plní ho `UpozorneniProvider` v components/Zvonek.js). */
export const UpozorneniCtx = createContext({
  items: [], neprectenych: 0, nacteno: false, push: "nejde",
  obnovit() {}, precist() {}, otevrit() {}, zapnout() {},
});
export const useUpozorneni = () => useContext(UpozorneniCtx);
